import React from 'react';

import { Tooltip } from '@mui/material';
import VerifiedIcon from '@mui/icons-material/Verified';

import { COLOR_VERIFIED_TICK } from 'src/utils/const';

const VerifiedTag = ({ size, tooltipTitle }: { size?: 'small' | 'inherit' | 'large' | 'medium' | undefined, tooltipTitle?: string }) => {
  return (
    <Tooltip title={tooltipTitle || 'Airbtics Verified Market'} arrow>
      <VerifiedIcon sx={{ color: COLOR_VERIFIED_TICK }} fontSize={size ? size : 'large'} />
    </Tooltip>
  );
};

export default VerifiedTag;
